<template>
  <div class="protocol-bd tb">
    <div class="search-hd">
      <el-form :inline="true" class="search-form" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.protocol_add" type="primary" icon="el-icon-plus" @click="onAddProtocol">{{ funcView.protocol_add }}</el-button>
          <el-button v-if="formSearch.protocolType === '2' && funcView.protocol_batch_publish" :disabled="!tableSelect.length" @click="batchPublishVersion">
            <i class="icon icon-fabu"></i>
            {{ funcView.protocol_batch_publish }}
          </el-button>
          <el-button v-if="formSearch.protocolType === '2' && funcView.protocol_batch_republish" :disabled="!batchRepublishVisible" @click="batchRepublishVersion">
            <i class="icon icon-fabu"></i>
            {{ funcView.protocol_batch_republish }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_protocol.xybmxymc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group v-model="formSearch.protocolType" size="small" @change="onPageChange({ page: 1 })">
            <el-radio-button v-for="(item, index) in protocolTypes" :label="item.value" :key="index">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table v-model="tableSelect" type="checkbox" height="100%" :index="true" :data="tableList" tableCode="protocol_manage" @sort="sortChange" @filter="filterChange" :slots="['action']">
        <template v-slot:action="scope">
          <span>
            <el-button v-if="funcView.protocol_edit" type="text" size="mini" @click="onEditProtocol(scope.row)">{{ funcView.protocol_edit }}</el-button>
            <el-button type="text" size="mini" v-if="(formSearch.protocolType === '2' || formSearch.protocolType === '3') && funcView.protocol_publish_record" @click="checkPublishRecord(scope.row)">
              {{ funcView.protocol_publish_record }}
            </el-button>
            <el-dropdown
              v-if="funcView.protocol_del || funcView.protocol_publish || funcView.protocol_tim_create || funcView.protocol_tim_record"
              @command="onCommand($event, scope.row)"
              style="vertical-align: middle"
            >
              <el-button type="text" size="mini">
                <span class="more">{{ $t('Common.com_more_action') }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="del" v-if="funcView.protocol_del">{{ funcView.protocol_del }}</el-dropdown-item>
                <el-dropdown-item command="publish" v-if="(formSearch.protocolType === '2' || formSearch.protocolType === '3') && funcView.protocol_publish">
                  {{ funcView.protocol_publish }}
                </el-dropdown-item>
                <el-dropdown-item command="timCreate" v-if="(formSearch.protocolType === '2' || formSearch.protocolType === '3') && funcView.protocol_tim_create">
                  {{ funcView.protocol_tim_create }}
                </el-dropdown-item>
                <el-dropdown-item command="timRecord" v-if="(formSearch.protocolType === '2' || formSearch.protocolType === '3') && funcView.protocol_tim_record">
                  {{ funcView.protocol_tim_record }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 协议版本发布dialog -->
    <publish-version-dialog
      v-if="showPublishDialog"
      @close="showPublishDialog = false"
      :protocolId="editModel.data.protocolId"
      :tcpVersion="editModel.data.tcpVersion"
      :model="editModel"
      @success="onPublishSuccess"
    ></publish-version-dialog>
    <publish-record-dialog
      v-if="showPublishRecordDialog"
      @close="showPublishRecordDialog = false"
      :protocolId="editModel.data.protocolId"
      :protocolCode="editModel.data.protocolCode"
    ></publish-record-dialog>
    <tim-record-dialog v-if="timRecordVisible" @close="timRecordVisible = false" :model="timRecordModel"></tim-record-dialog>
    <batch-republish-version-dialog
      v-if="showBatchRepublishRecordDialog"
      @close="showBatchRepublishRecordDialog = false"
      @success="onPublishSuccess"
      @fail="onPublishFail"
      :model="batchRepublishRecordModel"
    ></batch-republish-version-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// -todo
import publishVersionDialog from './children/publish_version_dialog.vue';
import publishRecordDialog from './children/publish_record_dialog.vue';
import timRecordDialog from './children/tim_record_dialog.vue';
import batchRepublishVersionDialog from './children/batch_republish_version_dialog.vue';

export default {
  name: 'protocol',
  mixins: [],
  components: {
    publishVersionDialog,
    publishRecordDialog,
    timRecordDialog,
    batchRepublishVersionDialog,
  },
  props: {},
  data() {
    return {
      provide: true,
      showPublishDialog: false,
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        dataTimes: [],
        protocolType: '1',
      },
      totalRows: 0,
      tableList: [],

      tableSelect: [],

      showPublishRecordDialog: false,

      editModel: {},

      timRecordVisible: false,
      timRecordModel: {},

      showBatchRepublishRecordDialog: false,
      batchRepublishRecordModel: {},
    };
  },
  computed: {
    protocolTypes() {
      return [
        {
          label: this.$t('dms_protocol.biao_zhun_xie_yi'),
          value: '1',
        },
        {
          label: this.$t('dms_protocol.yan_sheng_xie_yi'),
          value: '2',
        },
        {
          label: this.$t('dms_protocol.ding_zhi_xie_yi'),
          value: '3',
        },
      ];
    },
    batchRepublishVisible() {
      if (!this.tableSelect.length) {
        return false;
      }
      return !this.tableSelect.some(item => !item.isPublish);
    },
  },
  methods: {
    // 批量重新发布
    batchRepublishVersion() {
      const list = this.tableSelect;
      const tips = this.$t('dms_protocol.nqdycxfbxzdogxym', [list.length]);
      this.$showConfirm(tips).then(() => {
        this.batchRepublishRecordModel = {
          title: this.$t('dms_protocol.chong_xin_fa_bu'),
          data: list,
        };
        this.showBatchRepublishRecordDialog = true;
      });
    },
    // 批量发布
    batchPublishVersion() {
      const list = this.tableSelect;
      const tips = this.$t('dms_protocol.nqdyfbxzdogxym', [list.length]);
      this.$showConfirm(tips).then(() => {
        const data = { ...list[0] };
        data.tcpVersion = '';
        this.editModel = { data: list[0], title: this.$t('dms_protocol.pi_liang_fa_bu'), isBatch: true, list };
        this.showPublishDialog = true;
      });
    },
    onAddProtocol() {
      this.clearTagByKeep('protocol_item');
      this.jump('/redirect/iot/protocol/add', {
        parentPath: '/iot/protocol',
        protocolType: this.formSearch.protocolType,
      });
    },
    onEditProtocol(row) {
      this.clearTagByKeep('protocol_item');
      this.jump('/redirect/iot/protocol/edit', {
        parentPath: '/iot/protocol',
        protocolCode: row.protocolCode,
        protocolType: this.formSearch.protocolType,
      });
    },
    onCommand(e, row) {
      if (e === 'publish') {
        this.onPublish(row);
      }
      if (e === 'timCreate') {
        this.timCreate(row);
      }
      if (e === 'timRecord') {
        this.showTimRecord(row);
      }
      if (e === 'del') {
        this.onDel(row);
      }
    },
    showTimRecord(row) {
      this.timRecordModel = {
        data: row,
        title: this.$t('dms_protocol.Timji_lu'),
      };
      this.timRecordVisible = true;
    },
    timCreate(row) {
      this.$showConfirm(this.$t('dms_protocol.nqryscTimxdTimwjjxxy')).then(() => {
        this.$postJSON(`${apis.protocolPublishTimPublish}/${row.protocolId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    checkPublishRecord(row) {
      this.editModel = {
        data: row,
        title: this.$t('dms_protocol.fa_bu_ji_lu'),
      };
      this.showPublishRecordDialog = true;
    },
    onPublishSuccess() {
      this.getTableList();
    },
    onPublishFail() {
      this.getTableList();
    },
    onPublish(row) {
      this.editModel = { data: row, title: this.$t('dms_protocol.xie_yi_fa_bu') };
      this.showPublishDialog = true;
    },
    getTableList() {
      this.$getJSON(apis.ProtocolPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    exportTable() {},
    onDel(row) {
      this.$showConfirm(this.$t('dms_protocol.nqdyscgxym')).then(() => {
        this.$postJSON(`${apis.ProtocolDelete}/${row.protocolId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getFuncView();

  },
  activated: function () {
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.el-button--text {
  line-height: 24px;
}

.more {
  padding-left: 8px;
}
</style>
